import $ from "jquery";
import { FireComponent } from "@component";

export class AccordionsList extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $button: this.findElement("button"),
    };
  }

  _initCollapse() {
    this.elements.$button.on("click", function (e) {
      var collapse = $(e.currentTarget)
          .closest(".accordions-list__item")
          .find(".accordions-list__item-collapse"),

        inner = $(e.currentTarget)
          .closest(".accordions-list__item")
          .find(".accordions-list__item-inner"),

        height = inner.height();

      if ($(this).hasClass("open")) {
        $(this).text("+ Learn More");
        $(this).removeClass("open");
        collapse.removeClass("open").css("max-height", 0);
      } else {
        $(this).text("- Close");
        $(this).addClass("open");
        collapse.addClass("open").css("max-height", height);
      }
    });
  }

  init() {
    if (!this.componentExists) return;
    this._initCollapse();
  }
}
